import { Row } from '@/components/layout/layout'
import React from 'react'
import { getBEMCls } from '@/utils/classname'

import './form-title.scss'

interface FormTitleProps {
    title: string
    hasLine?: boolean
}

const FormTitle: React.FC<FormTitleProps> = props => {
    const cls = (...args: string[]) => getBEMCls('form-title', ...args)

    return (
        <Row
            className={cls('container')}
            style={
                props.hasLine
                    ? {
                          borderBottom: '1px solid #dddddd',
                      }
                    : void 0
            }
            data-overflow-auto
            data-justify-content-space-between
            data-align-items-center
        >
            <Row data-align-items-center className={cls('title-wrap')}>
                <i className={cls('title-wrap', 'line')}></i>
                <span className={cls('title-wrap', 'title')}>{props.title}</span>
            </Row>
            {props.children}
        </Row>
    )
}

FormTitle.defaultProps = {
    hasLine: true,
}

export default FormTitle
